// extracted by mini-css-extract-plugin
export default {"mark":"styles_mark__8XXGk","mark__value":"styles_mark__value__YOFnL"};